import { arrayToColumns } from './helpers';
import * as SubParts from './IndexGridCells';
import IndexGridV2 from './IndexGridV2';
import { EmptyMessage } from './parts';

export default Object.assign(IndexGridV2, SubParts, { EmptyMessage, arrayToColumns });
